function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 5V11H21V21H3V7H9V5L12 2L15 5ZM5 19H7V17H5V19ZM7 15H5V13H7V15ZM5 11H7V9H5V11ZM11 19V17H13V19H11ZM11 13V15H13V13H11ZM11 11V9H13V11H11ZM11 5V7H13V5H11ZM19 19H17V17H19V19ZM17 15H19V13H17V15Z",
  fill: "#979797"
});

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  maskType: "alpha",
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 2,
  width: 18,
  height: 19
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 5V11H21V21H3V7H9V5L12 2L15 5ZM5 19H7V17H5V19ZM7 15H5V13H7V15ZM5 11H7V9H5V11ZM11 19V17H13V19H11ZM11 13V15H13V13H11ZM11 11V9H13V11H11ZM11 5V7H13V5H11ZM19 19H17V17H19V19ZM17 15H19V13H17V15Z",
  fill: "white"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/pharmacies.17b44a40.svg";
export { SvgComponent as ReactComponent };